import Vue from 'vue'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import firebase from 'firebase'

Vue.config.productionTip = false

const config = {
  apiKey: "AIzaSyBs8cFXoDOyYnf1GBZ2N0_9JvNHE2pPfaA",
  authDomain: "lottery-c0fe0.firebaseapp.com",
  databaseURL: "https://lottery-c0fe0.firebaseio.com",
  projectId: "lottery-c0fe0",
  storageBucket: "lottery-c0fe0.appspot.com",
  messagingSenderId: "10582078556",
  appId: "1:10582078556:web:5f078099aceee610dd6299",
  measurementId: "G-FDVP8JPVE5"
}
firebase.initializeApp(config);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
